import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  SendMiniStressNotificationData,
  ActionType,
} from "models/stressCheck/miniStressSendNotification";
import { IResponse } from "models";
import { httpStatus } from "configs/httpStatus";
import { sendMiniStressNotification } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./miniStressSendNotiActions";

function* sendMiniStressNotificationSaga({
  payload,
}: {
  payload: SendMiniStressNotificationData;
}) {
  try {
    const response: IResponse = yield call(sendMiniStressNotification, payload);

    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else if (response.status === httpStatus.StatusUnauthorized) {
      yield put(handleErrorAction(response.message || ""));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onSendMiniStressNotificationWatcher() {
  yield takeLatest(
    ActionType.SEND_MINI_NOTIFICATION as any,
    sendMiniStressNotificationSaga
  );
}

export default [fork(onSendMiniStressNotificationWatcher)];
